import types from '../mutation-types';
import ScheduledMessagesAPI from '../../api/scheduledMessages';

export const state = {
  records: [],
  uiFlags: {
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },

  getScheduledList(_state) {
    return Array.isArray(_state.records) ? _state.records : [];
  },

  getScheduled(_state) {
    return _state.records.length ? _state.records[0] : null;
  },
};

export const actions = {
  create: async ({ commit }, data) => {
    commit(types.SET_SCHEDULED_MESSAGES_TEMPLATE_UI_FLAG, { isCreating: true });

    try {
      const response = await ScheduledMessagesAPI.create(data);
      commit('UPSERT_SCHEDULED_MESSAGES', response.data);
    } finally {
      commit(types.SET_SCHEDULED_MESSAGES_TEMPLATE_UI_FLAG, {
        isCreating: false,
      });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_SCHEDULED_MESSAGES_TEMPLATE_UI_FLAG, { isDeleting: true });

    try {
      await ScheduledMessagesAPI.delete(id);
      commit('REMOVE_SCHEDULED_MESSAGE', id);
    } finally {
      commit(types.SET_SCHEDULED_MESSAGES_TEMPLATE_UI_FLAG, {
        isDeleting: false,
      });
    }
  },
};

export const mutations = {
  [types.SET_SCHEDULED_MESSAGES_TEMPLATE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_SCHEDULED_MESSAGE](_state, record) {
    if (Array.isArray(record)) {
      let records = record;
      if (Array.isArray(records[0])) records = records[0];

      _state.records = Array.isArray(records) ? records : [];
      return;
    }

    if (!record || !record.id) return;

    const index = _state.records.findIndex(
      item => Number(item.id) === Number(record.id)
    );

    if (index === -1) {
      _state.records.push(record);
    } else {
      _state.records.splice(index, 1, record);
    }
  },

  SET_SCHEDULED_MESSAGES_RECORDS(_state, payload) {
    let records = payload;

    if (Array.isArray(records) && Array.isArray(records[0])) {
      records = records[0];
    }

    if (!Array.isArray(records)) {
      _state.records = [];
      return;
    }

    _state.records = records;
  },

  UPSERT_SCHEDULED_MESSAGES(_state, payload) {
    let records = payload;
    if (!Array.isArray(records)) records = [records];

    records.forEach(record => {
      if (!record || !record.id) return;

      const index = _state.records.findIndex(
        item => Number(item.id) === Number(record.id)
      );

      if (index === -1) {
        _state.records.push(record);
      } else {
        _state.records.splice(index, 1, record);
      }
    });
  },

  REMOVE_SCHEDULED_MESSAGE(_state, id) {
    _state.records = _state.records.filter(
      item => Number(item.id) !== Number(id)
    );
  },

  CLEAR_SCHEDULED_MESSAGES(_state) {
    _state.records = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
